import { SnackbarProvider } from "notistack";

const SnackProvider = ({ children }) => {
  return <SnackbarProvider>{children}</SnackbarProvider>;
};

export default SnackProvider;
